import { useEffect, useState } from 'react';
import { fetchBracketPreview } from '@/lib/bracket/shareApi';

// Live bracket preview for the wizard: seeds shown as "1. Team" so organizers see who has the byes.
export function useWizardBracket(format, teams, positions) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const key = JSON.stringify([format, teams.map((t) => [t.id, t.name]), positions]);
  useEffect(() => {
    if (teams.length < 2) { setData(null); return undefined; }
    let alive = true;
    const t = setTimeout(() => {
      fetchBracketPreview(format, teams.length, {
        teams: teams.map((tm, i) => ({ id: tm.id, name: `${i + 1}. ${tm.name}` })), positions,
      })
        .then((d) => { if (alive) { setData(d); setError(''); } })
        .catch((e) => { if (alive) setError(e.message); });
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, error };
}
